// Persistent list of WebSocket connection presets used by the connection
// panel in the sidebar. Each entry is { id, label, url }. Stored via the
// shared BrowserStore so it survives reloads.

import store from './storage';

export const STORE_KEY = 'connectionWsPresets';
export const CHANGE_EVENT = 'connection-ws-presets-changed';

export const DEFAULT_PRESETS = [
    { id: 'default-local', label: 'Local SITL', scheme: 'ws', host: '127.0.0.1:5555' },
];

const splitUrl = (url) => {
    if (!url || typeof url !== 'string') return { scheme: 'ws', host: '' };
    const m = url.match(/^(wss?):\/\/(.*)$/i);
    if (m) return { scheme: m[1].toLowerCase(), host: m[2] };
    return { scheme: 'ws', host: url };
};

const composeUrl = (scheme, host) => {
    const s = scheme === 'wss' ? 'wss' : 'ws';
    const h = (host || '').replace(/^\/+/, '');
    return `${s}://${h}`;
};

const ensureIds = (arr) => arr.map((p, i) => {
    const fromUrl = splitUrl(p && p.url);
    const scheme = (p && p.scheme === 'wss') ? 'wss' : (p && p.scheme === 'ws') ? 'ws' : fromUrl.scheme;
    const host = (p && typeof p.host === 'string' && p.host) ? p.host : fromUrl.host;
    const url = composeUrl(scheme, host);
    return {
        id: p && p.id ? p.id : `preset-${Date.now()}-${i}`,
        label: (p && typeof p.label === 'string') ? p.label : (url || `Preset ${i + 1}`),
        scheme,
        host,
        url,
        signingKey: (p && p.signingKey) || '',
    };
});

export function loadWsPresets() {
    const raw = store.get(STORE_KEY, null);
    if (!Array.isArray(raw) || raw.length === 0) return ensureIds(DEFAULT_PRESETS);
    return ensureIds(raw);
}

export function saveWsPresets(presets) {
    const cleaned = ensureIds(Array.isArray(presets) ? presets : []);
    store.set(STORE_KEY, cleaned);
    try {
        window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { presets: cleaned } }));
    } catch (_) { /* noop */ }
    return cleaned;
}
